function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "layer1_2_",
  transform: "translate(-1339.439 -204.359)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g2562_2_",
  transform: "translate(-2030.334 564.278)"
}, /*#__PURE__*/React.createElement("path", {
  id: "rect2467_2_",
  d: "M3373.777-359.919a3.992,3.992,0,0,0-4,4v12a3.993,3.993,0,0,0,4,4h22.5a3.992,3.992,0,0,0,4-4v-12a3.993,3.993,0,0,0-4-4Zm-.114,2.01h7.8v16h-7.7a1.993,1.993,0,0,1-1.994-1.994v-12A2,2,0,0,1,3373.664-357.909Zm9.809,0h12.792a1.993,1.993,0,0,1,1.994,1.994v12a1.993,1.993,0,0,1-1.994,1.994h-12.792Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rect2483_2_",
  d: "M3373.923-357.211a1.319,1.319,0,0,0-1.3,1.33,1.322,1.322,0,0,0,1.3,1.346h1.929v10.62a1.319,1.319,0,0,0,1.33,1.3,1.333,1.333,0,0,0,1.346-1.3v-13.295Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g2541_2_",
  transform: "translate(-5.32 -351.907)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path2522_2_",
  d: "M3390.882,8.917a1.311,1.311,0,0,0,1.848-.211l9.1-11.787a1.323,1.323,0,0,0-.259-1.848,1.311,1.311,0,0,0-1.848.211l-9.1,11.787A1.309,1.309,0,0,0,3390.882,8.917Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2532_2_",
  d: "M3393.46-5.172a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A2.993,2.993,0,0,0,3393.46-5.172Zm0,2.156a.865.865,0,0,1,.859.859.865.865,0,0,1-.859.859.865.865,0,0,1-.859-.859A.865.865,0,0,1,3393.46-3.016Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2539_2_",
  d: "M3398.972,3.145a3,3,0,1,0,3,3A3,3,0,0,0,3398.972,3.145Zm0,2.156a.859.859,0,1,1-.859.859A.865.865,0,0,1,3398.972,5.3Z"
}))));

var SvgProcent = function SvgProcent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.513,
    height: 20.007,
    viewBox: "0 0 30.513 20.007",
    fill: "#ec6d00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProcent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/procent.943142de.svg";
export { ForwardRef as ReactComponent };